'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { getAccountInfo, getRegistries } from '@/(front-desk)/utils/dataFetch'
import { handleAccount } from '@/(front-desk)/store'
import Navbar from '@/(front-desk)/components/Navbar'
import Footer from '@/(front-desk)/components/Footer'
import Error from '@/error'
import lscache from 'lscache'

export default function FrontPageLayout({ children }) {

    const pathname = usePathname()
    const dispatch = useDispatch()
    const account = useSelector((state) => state.account)
    const sentryErrorEventId = useSelector((state) => state.global).sentryErrorEventId

    useEffect(() => {
        getRegistries(dispatch)
    }, [])

    useEffect(() => {
        if (lscache.get('access')) {
            if (account.data === null) {
                getAccountInfo(dispatch)
            }
        }
        else {
            dispatch(handleAccount.actions.setData(false))
        }
    }, [account.data])

    return (
        <>
        { pathname !== '/handbook' && <Navbar />}
        {children}
        { pathname !== '/handbook' && <Footer />}
        { sentryErrorEventId && <Error id={sentryErrorEventId} /> }
        </>
    )
}
